export default function Tutor (){

    return(
        <div>My Tutor...</div>
    )
}